import { TrackingRequirements } from "../../../powerbroker/src/tracking/TrackingRequirements";
import { DriverInformation } from "../DriverInformation";
import { MovementDataFusionSummary } from "../MovementDataFusionSummary";
import { Button, CityState, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, StarRating, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAssignedMovementOverview extends Layout {
    buttonClassicAdvances: Button;
    buttonModifyPay: Button;
    buttonSendSmsDriver2: Button;
    buttonSendSmsDriver: Button;
    cityStateCarrierEmptyFromCityId: CityState;
    citystateCarrier: CityState;
    horizontalspacer1: HorizontalSpacer;
    imageNextStopType: Image;
    imageTransferToSettlement: Image;
    labelCarrier: Label;
    labelCarrierContact: Label;
    labelCarrierEmail: Label;
    labelCarrierPhone: Label;
    labelContactHeader: Label;
    labelDistanceToNextStop: Label;
    labelDriverInformation: Label;
    labelEquipmentRequired: Label;
    labelEtaToNextStop: Label;
    labelMilesToPickup: Label;
    labelNextSchedCall: Label;
    labelNextScheduledHeader: Label;
    labelNextStop: Label;
    labelNextStopAddress2: Label;
    labelNextStopAddress: Label;
    labelNextStopCity: Label;
    labelNextStopDistance: Label;
    labelNextStopEta: Label;
    labelNextStopLocation: Label;
    labelNextStopScheduled: Label;
    labelNextStopTypeCaption: Label;
    labelOrderstemperatureMax: Label;
    labelOrderstemperatureMin: Label;
    labelOverrideDriver2Cell: Label;
    labelOverrideDriver2Name: Label;
    labelOverrideDriverCell: Label;
    labelOverrideDriverName: Label;
    labelOverrideDrvr2Email: Label;
    labelOverrideDrvrEmail: Label;
    labelPayeeName: Label;
    labelReferenceNumbers: Label;
    labelTeam: Label;
    labelTemperatureRange: Label;
    labelTo: Label;
    labelTotalPayPerMile: Label;
    labelTrackingCaption: Label;
    labelTrackingRequired: Label;
    layoutDriverInformation: DriverInformation;
    layoutMovementDataFusionSummary: MovementDataFusionSummary;
    layoutTrackingRequirements: TrackingRequirements;
    panelBuyToMarket: Panel;
    panelCarrier: Panel;
    panelCarrierInfo: Panel;
    panelContent: Panel;
    panelDataFusion: Panel;
    panelDriver: Panel;
    panelDriverInfo: Panel;
    panelDriverSummary: Panel;
    panelDriverSummaryInner: Panel;
    panelEquipment: Panel;
    panelEquipmentRequired: Panel;
    panelLoadIcons: Panel;
    panelMargin: Panel;
    panelMoveInfo: Panel;
    panelNextStopHeader: Panel;
    panelNextStopLocationInfo: Panel;
    panelNextStopType: Panel;
    panelRefNbrs: Panel;
    panelReferenceNumbers: Panel;
    panelStopInfo: Panel;
    panelTempRange: Panel;
    panelTempRangeInner: Panel;
    panelTotalAdvances: Panel;
    panelTotalCharges: Panel;
    panelTotalPay: Panel;
    panelTracking: Panel;
    sourceCalculateOverridePay: DataSource;
    sourceDataFusionMovementSummary: DataSource;
    sourceEquipMatchDetail: DataSource;
    sourceMovement: DataSource;
    starratingRatingStarCount: StarRating;
    switchExcludeBuyToMarket: Switch;
    tabCarrierInfo: Tab;
    tabDriverInfo: Tab;
    tabTrackingRequirements: Tab;
    tableEquipmentRequired: Table;
    tabsetCarrierDriver: Tabset;
    textboxBuyToMarket: Textbox;
    textboxBuyToMarketPercent: Textbox;
    textboxCarrierTractor: Textbox;
    textboxCarrierTrailer: Textbox;
    textboxCarrierTrailerType: Textbox;
    textboxCommissionableMargin: Textbox;
    textboxCompanyTrailer: Textbox;
    textboxFreightCharges: Textbox;
    textboxMargin: Textbox;
    textboxMarginPercentage: Textbox;
    textboxNetPay: Textbox;
    textboxOtherCharges: Textbox;
    textboxOverridePayAmt: Textbox;
    textboxPayAdjustments: Textbox;
    textboxProNbr: Textbox;
    textboxTotalAdvances: Textbox;
    textboxTotalCharge: Textbox;
    textboxTotalPay: Textbox;
    textboxXfer2settleDate: Textbox;
}
